import {
	ADMINGETRISKRULELIST_SUCCESS,
	ADMINGETRISKRULELIST_FAILED,
	RESET_ADMINGETRISKRULELIST,
	LOADING_ADMINGETRISKRULELIST,
	NETWORK_ERROR_ADMINGETRISKRULELIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetRiskRuleList = () => {
	return { type: RESET_ADMINGETRISKRULELIST };
};

const adminGetRiskRuleList = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETRISKRULELIST });
	await adminServices
		.post("getRiskRuleList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetRiskRuleListsuccess(res.data));
					break;
				default:
					dispatch(adminGetRiskRuleListFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETRISKRULELIST,
				payload: err
			});
		});
};
function adminGetRiskRuleListsuccess(data) {
	return {
		type: ADMINGETRISKRULELIST_SUCCESS,
		payload: data
	};
}
function adminGetRiskRuleListFailed(data) {
	return {
		type: ADMINGETRISKRULELIST_FAILED,
		payload: data
	};
}

export { resetAdminGetRiskRuleList, adminGetRiskRuleList };
